import { Overrides, ComponentName, OverridesResult, OverridesComponent } from './types';

function getComponents<T extends Overrides>(
    defaultComponents: {
        [P in ComponentName<T>]: OverridesComponent;
    },
    overrides: Partial<T>,
): OverridesResult<T> {
    const result = {} as OverridesResult<T>;
    const componentNames = Object.keys(defaultComponents) as ComponentName<T>[];

    componentNames.forEach((componentName) => {
        const overridesComponent = overrides[componentName]?.component as OverridesComponent;
        const overridesProps = overrides[componentName]?.props ?? {};

        result[componentName] = {
            component: overridesComponent ?? defaultComponents[componentName],
            props: { ...overridesProps },
        } as Required<T[ComponentName<T>]>;
    });

    return result;
}

export default getComponents;
